/**
 * Zoom in on the product image
 */
function zoomIn(event) {
  var target = event.target;
  var element = target.parentElement.querySelector(".imgOverlay");
  var img = target.parentElement.querySelector(".imgZoom");
  var posX = event.offsetX ? event.offsetX : event.pageX - img.offsetLeft;
  var posY = event.offsetY ? event.offsetY : event.pageY - img.offsetTop;
  element.style.display = "inline-block";
  element.style.backgroundPosition = -posX * 2 + "px " + -posY * 2 + "px";
}

/**
 * Zoom out of the product image
 */
function zoomOut(event) {
  var target = event.target;
  var element = target.parentElement.querySelector(".imgOverlay");
  element.style.display = "none";
}

// The product images
var images = Array.from(
  document.getElementsByClassName("productheader__image--main-item")
);

// Loop over all images and add mouse event listeners
images.forEach(function (img, i) {
  img.addEventListener("mousemove", zoomIn);
  img.addEventListener("mouseout", zoomOut);
});
